import { Component } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { Router } from '@angular/router';

@Component({
    selector: 'flyfreely-portal-ui-airspace-risk-view',
    templateUrl: './airspace-risk-view.component.html',
    styleUrls: ['./airspace-risk-view.component.scss']
})
export class AirspaceRiskViewComponent {
    iframeUrl: SafeResourceUrl;
    targetParameters: string;
    constructor(private domSanitizer: DomSanitizer, private router: Router) {
        this.targetParameters =
            this.router.getCurrentNavigation()?.extras?.state?.locationName;
    }

    ngOnInit() {
        if (this.targetParameters != null) {
            const normalisedParameter = this.targetParameters
                .split(' ')
                .join('')
                .trim()
                .toLowerCase();

            this.iframeUrl = this.domSanitizer.bypassSecurityTrustResourceUrl(
                `http://localhost:8080/?scenario=${normalisedParameter}`
            );
        }
    }
}
